var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"width":"fit-content","height":"100%"},attrs:{"align-center":""}},[_c('div',{staticClass:"home-footer-info ml-1",attrs:{"id":"current-workspace-text"}},[_vm._v("\n    "+_vm._s(_vm.$tc("Workspace", 1) + ": " + _vm.activeWorkspace)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a666a49","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/ActiveWorkspace.vue
// module id = null
// module chunks = 